export const DEFAULT_FILTER = {
  nome_bem: '',
  nm_comissionado: '',
  documento_cliente: '',
  cd_grupo: '',
  cd_cota: '',
  nome_plano: '',
  cd_ponto_venda: '',
  id_reserva: '',
  codigo_pagamento_cliente: '',
  opcao_furo: '',
  nm_unidade_negocio: ''
}

export const DEFAULT_CUSTOM_FILTER = {
  cpf_cnpj: '',
  cpf_cnpj_pv: '',
  id_carrinho: '',
  qtd_cotas_carrinho: '',
  cotas_multiplas: '',
  data_inicial: '',
  data_final: '',
  range_valor_bem: [0, 0],
  email: '',
  nome_cliente: '',
  nome_bem: '',
  nome_plano: '',
  nm_unidade_negocio: '',
  nm_comissionado: '',
  status_pedido: '',
  range_prazo_comercializacao: [0, 0],
  id_empresa_venda_logada: null,
  status: '',
  hash_contrato: '',
  origem_acesso: '',
  marca: '',
  origem_venda: '',
  forma_pagamento: '',
  status_pagamento: '',
  login: '',
  perfil_comercial: '',
  origem_contrato: '',
  tipo_cota: '',
  cd_cota: '',
  status_alocacao: '',
  cd_plano_venda: '',
  tipo_indice: '',
  categoria_plano: '',
  tipo_grupo: '',
  cd_simulacao_ed: ''
}
